(function (seraphicPlusLine, $, undefined) {
	//-----------------------------------------
	// Namespaced Functions
	//-----------------------------------------

    //-----------------------------------------
	// On Load/Refresh
	//-----------------------------------------

  	//-----------------------------------------
	// Events/Watchers
	//-----------------------------------------
  	$(document).on("click", ".PlusButton button", function() {
        $(".PlusButton button").removeClass("ActiveButton");
        var plusProduct = $(this).attr("data-selection");

        $(this).addClass("ActiveButton");
        $(".IconsPacket").hide();
        $("." + plusProduct).show();

        return false;
    });
} (window.seraphicPlusLine = window.seraphicPlusLine || {}, jQuery));
